<template>
  <div>
    <h2>FormCommittee</h2>
  </div>
</template>

<script>
  export default {
    name: "FormCommittee",
  }
</script>

<style lang="css" scoped>

</style>